import {Component, ViewChild} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {ApiService} from "@ctms/api.service";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {Page} from "@ctms/api/api.interfaces";
import {BreadcrumbService} from "@cdss/services/breadcrumb.service";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'demo-dashboard',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, RouterLink],
    providers: [ApiService],
    templateUrl: './dashboard.component.html'
})
export class DemoDashboardComponent {
    errorMessage!: string;
    loading = false;

    @ViewChild("table") table: any;

    page: Page = {
        size: 10,
        start: 0,
        totalCount: 3
    };
    offset: number = 0
    rows: any[
    ] = [
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 2,
            name: "Sophie Richardson",
            code: "0129039303",
            weight: 33.8,
            bmi: 11.7,
            plan: "Comfort"
        },
        {
            id: 3,
            name: "Harriet Lawson",
            code: "0129039302",
            weight: 33.2,
            bmi: 11.6,
            plan: "Comfort"
        },
    ]
    sessions = [
        {
            patient: "Charlotte Hayes",
            code: "0129039302",
            date: "26/07/2025 09:00 AM",
        },
        {
            patient: "Jane Smith",
            code: "0129039302",
            date: "26/07/2025 11:30 AM",
        },
        {
            patient: "Sophie Richardson",
            code: "0129039302",
            date: "26/07/2025 12:30 AM",
        },
        {
            patient: "Oliver Bennett",
            code: "0129039302",
            date: "26/07/2025 04:30 PM",
        },
        {
            patient: "Lucy Chapman",
            code: "0129039302",
            date: "26/07/2025 04:00 PM",
        },
    ]
    sortField: string = 'participantCode'
    order: string = 'asc'

    filterForm: FormGroup

    constructor(
        public toastr: ToastrService,
        private breadcrumbService: BreadcrumbService,
    ) {
    }

    ngOnInit(): void {
        this.breadcrumbService.set([
            {title: "Dashboard", url: null},
        ])

        this.filterForm = new FormGroup({
            study: new FormControl(),
            site: new FormControl(),
            status: new FormControl(),
            lastName: new FormControl(),
            participantCode: new FormControl(),
            includesDemo: new FormControl(),
        });
    }

    reset(): void {

    }

    filter(): void {

    }

    setPage(pageInfo) {
        this.loading = true
        this.page.start = pageInfo.offset * this.page.size
        this.refreshRows()
    }

    sort(pageInfo) {
        this.loading = true
        this.sortField = pageInfo.sorts[0].prop
        this.order = pageInfo.sorts[0].dir
        this.table.offset = this.page.start
        this.refreshRows()
    }

    refreshRows() {

    }
}
